<template>
  <v-card :elevation="cardElevation" :tile="tile" :class="cssClass">
    <v-card-title v-if="!hideTitle">
      <slot name="title"></slot>
    </v-card-title>
    <v-card-subtitle v-if="!hideSubtitle">
      <slot name="subTitle"></slot>
    </v-card-subtitle>
    <v-card-text>
      <slot name="content"></slot>
    </v-card-text>
    <v-card-actions>
      <slot name="action"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CardContainer',
  props: ['elevation', 'tile', 'cssClass', 'hideTitle', 'hideSubtitle'],
  computed: {
    cardElevation() {
      return this.elevation ?? 2;
    },
    class() {
      return this.cssClass;
    },
  },
};
</script>

<style scoped>

</style>
